import Vue from "vue";
import Component from "vue-class-component";
import providers from "@/lib/api";

@Component
export default class WithUserTags extends Vue {
  public async userTagsUpdateData(tags: string[]) {
    const data: { fields: any } = { fields: { tags } };
    data.fields.userId = this.$store.state.user.id;
    const result = await providers.QuestionaryInfoProvider.update({ data });
    return ((result.fields.tags as any) as number[]).map(t => t.toString());
  }

  public async userTagsGetData(): Promise<string[]> {
    const result = await providers.QuestionaryInfoProvider.find({ id: this.$store.state.user.id });
    return ((result.fields.tags as any) as number[]).map(t => t.toString());
  }
}
